import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogContentText as MUIDialogContentText,
  DialogTitle,
  DialogActions,
  DialogActionsProps,
  Box,
  Grid,
  ListItemText as MUIListItemText,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styled from 'styled-components';
import React from 'react';
import { PaperComponentProps } from 'spw-components/dialogs/total-program/types';
import { colors } from 'spw-theme';
import { GridProps } from '@mui/material/Grid';
import { SPWDeleteButton } from 'spw-shared/globalComponents/buttons';
import { isWindows } from 'spw-shared/utils';

export const SelectLabel = styled.label`
  display: flex;
  margin-bottom: 8px;
`;

export const DialogContentHeader = styled(MUIDialogContentText)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.fontColor};
    margin-bottom: 8px;
  }
`;

export const DialogContentText = styled(MUIDialogContentText)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.fontColor};
  }
`;

export const RemoveSpaceTypeCustomDialog = withStyles({
  root: {
    '& .MuiPaper-root': {
      minWidth: '636px',
    },
  },
})((props: DialogProps & { PaperProps?: Partial<PaperComponentProps> }) => (
  <Dialog {...props} disableScrollLock />
));

export const RemoveSpaceTypeDialogTitle = styled(DialogTitle)`
  && {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const RemoveSpaceTypeDialogContent = styled(DialogContent)`
  && {
    overflow: hidden;
    padding: 8px 0px 8px 24px;
  }
`;

export const RemoveSpaceTypeCautionMessage = styled.div`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;

    div {
      &.red {
        font-style: normal;
        font-weight: bold;
        color: #f01346;
      }
    }

    p {
      margin-bottom: 8px;
      margin-top: 8px;
    }
  }
`;

export const SpaceTypeText = styled.div`
  && {
    margin-top: 16px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;

    span {
      &.bold {
        font-weight: 500;
      }
    }
  }
`;

export const RemoveSpaceTypeDialogBox = styled.div`
  && {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 46px;
    margin-left: 8px;
  }

  &&.ml-0 {
    margin-left: 0px;
  }

  &.selected {
    background: #eeeeee;
    font-weight: 500;
  }

  &.selectable {
    cursor: pointer;
  }
`;

export const RemoveSpaceTypeDialogActions = styled(
  (props: DialogActionsProps) => (
    <DialogActions {...props}>{props.children}</DialogActions>
  )
)`
  && {
    display: flex;
    justify-content: flex-start;
    padding: 24px;
  }
`;

export const DeleteButton = styled(SPWDeleteButton)`
  && {
    border: 1px solid ${colors.red};
  }
`;

export const ScenariosSection = styled(Box)`
  && {
    margin-top: 32px;
    align-items: center;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-right: ${isWindows() ? '7px' : '24px'};
  }
`;

export const ScenariosContainer = styled(Box)`
  && {
    height: auto;
    padding-bottom: 216px;
  }
`;

export const ScenariosListContainer = styled.div`
  && {
    border-radius: 8px;
    border: 1px solid ${colors.veryLightGray};
    margin-bottom: 16px;

    > div:last-child {
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }
  }
`;

export const ScenariosListTitle = styled.div`
  && {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    height: 48px;
    background: #ffffff;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    align-items: center;
    padding: 0px 16px;

    b {
      font-weight: 500;
    }
  }
`;

export const WorksheetsNumber = styled(Box)`
  && {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ScenariosListHeader = styled(Grid)`
  && {
    height: 24px;
    background: #eeeeee;
    padding: 0px 16px;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
  }
`;
export const ScenariosListHeaderColumn = styled(Grid)`
  && {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
  }

  &&.right {
    justify-content: right;
  }
`;

export const ScenarioListRow = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    height: 48px;
    background: #ffffff;
    padding: 0px 16px;
    border-bottom: 1px solid ${colors.veryLightGray};
  }

  &&.child-row {
    padding-left: 32px;
  }

  &&.border-top {
    border-top: 1px solid ${colors.veryLightGray};
  }

  &&.border-bottom-0 {
    border-bottom: none;
  }
`;
export const ScenarioListColumn = styled(Grid)`
  && {
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;

    span {
      &.bold {
        font-weight: 500;
      }
    }
  }

  &&.right {
    justify-content: right;
  }
`;

export const DepartmentColumn = styled(Box)`
  && {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;

export const ListItemText = styled(MUIListItemText)`
  && {
    margin: 0px;

    span {
      max-width: 170px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &&.bold {
    span {
      font-weight: 500;
    }
  }
`;
